export default function setSearchCreateDateTillAction(searchCreateDateTill) {
    return {
        type: 'SET_SEARCH_CREATE_DATE_TILL',
        payload: searchCreateDateTill
    }
}